import { pdfRectToCanvasRect } from "../../../../../../utils/coordinateUtils";

const DEFAULT_ROW_TOLERANCE = 8;

export const buildVisibleTableRows = (
  fields = [],
  currentDocument = {},
  rowTolerance = DEFAULT_ROW_TOLERANCE,
) => {
  const viewportOrHeight =
    currentDocument?.viewport || currentDocument?.actualHeight || 792;
  const scale = currentDocument?.scaleFactor || 1;
  const viewportTransform = currentDocument?.viewport?.transform;
  const viewportScale = Array.isArray(viewportTransform)
    ? Math.hypot(viewportTransform[0] || 0, viewportTransform[1] || 0) || 1
    : scale;
  const visibleTolerance = rowTolerance * viewportScale;
  const projectedFields = fields.map((field) => {
    const rect = pdfRectToCanvasRect(
      field,
      viewportOrHeight,
      scale,
      currentDocument?.pageXMin || 0,
      currentDocument?.pageYMin || 0,
    );

    return {
      field,
      centerX: rect.left + rect.width / 2,
      centerY: rect.top + rect.height / 2,
    };
  });
  const rows = [];

  projectedFields
    .sort((a, b) => a.centerY - b.centerY)
    .forEach((projectedField) => {
      const lastRow = rows[rows.length - 1];

      if (
        lastRow &&
        Math.abs(projectedField.centerY - lastRow.refY) <= visibleTolerance
      ) {
        lastRow.projectedFields.push(projectedField);
        lastRow.refY =
          lastRow.projectedFields.reduce((sum, item) => sum + item.centerY, 0) /
          lastRow.projectedFields.length;
      } else {
        rows.push({
          refY: projectedField.centerY,
          projectedFields: [projectedField],
        });
      }
    });

  return rows.map((row) => ({
    refY: row.refY,
    fields: row.projectedFields
      .sort((a, b) => a.centerX - b.centerX)
      .map((item) => item.field),
  }));
};

export const getTableSelectionMode = (rows = [], selectedFieldCount = 0) => {
  const multiColumnRows = rows.filter((row) => row.fields.length >= 2);
  const distinctColumnCounts = new Set(
    multiColumnRows.map((row) => row.fields.length),
  );
  const maxColumnCount = rows.reduce(
    (max, row) => Math.max(max, row.fields.length),
    0,
  );
  const supportsPaisTableTagging =
    selectedFieldCount >= 4 &&
    multiColumnRows.length >= 2 &&
    maxColumnCount >= 2 &&
    distinctColumnCounts.size <= 2;
  const supportsGenericTableTagging =
    supportsPaisTableTagging ||
    (selectedFieldCount >= 2 && rows.length >= 2 && maxColumnCount === 1);

  return {
    supportsPaisTableTagging,
    supportsGenericTableTagging,
  };
};
